import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import socket from "../../../Socket";
import { Link } from "react-router-dom";

import storage from "../../../Storage";
import {
  decode,
  encode,
  getElement,
  sendNotfication,
  isEmail,
  Event,
  DEVELOPMENT,
  wait,
  randomString,
} from "../../../Helper";
import C from "../../../Constant";
import axios from "axios";

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 900px;
    margin: 20px auto;

    @media (max-width: 768px) {
      max-width: 100%;
      margin: 0;
      height: 100vh;
      display: flex;
      align-items: stretch;
    }

    @media (max-width: 480px) {
      max-width: 100%;
      margin: 0;
      height: 100vh;
    }
  }

  .modal-content {
    background-color: #232626;
    color: white;
    border-radius: 12px;
    border: none;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);

    @media (max-width: 768px) {
      border-radius: 0;
      height: 100vh;
      padding: 40px;
      max-height: 100vh;
    }

    @media (max-width: 700px) {
      border-radius: 0;
      height: 100vh;
      padding: 0px;
      max-height: 100vh;
    }
  }
`;

const LoginContainer = styled.div`
  display: flex;
  min-height: 500px;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 100vh;
    height: 100vh;
  }
`;

const LoginLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (max-width: 768px) {
    flex: 0 0 auto;
  }

  @media (max-width: 480px) {
    min-height: 30vh;
  }
`;

const LoginTopImage = styled.img`
  max-width: 100%;
  height: auto;

  @media (max-width: 768px) {
    width: 100%;
    object-fit: cover;
    max-height: 300px;
  }

  @media (max-width: 480px) {
    width: 100%;
    object-fit: cover;
    max-height: 300px;
  }
`;

const LoginLogoImage = styled.img`
  max-width: 150px;
  height: auto;

  @media (max-width: 768px) {
    max-width: 120px;
  }

  @media (max-width: 480px) {
    max-width: 100px;
  }
`;

const MobileCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    display: flex;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const LoginRight = styled.div`
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 30px 25px;
    flex: 1;
    min-height: 65vh;
    overflow-y: auto;
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
    min-height: 70vh;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
`;

const SignInTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  color: white;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;

  // @media (max-width: 768px) {
  //   display: none;
  // }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputLabel = styled.label`
  color: #9ca3af;
  font-size: 14px;
  font-weight: 500;
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledInput = styled.input`
  width: 100%;
  background-color: #1e2121;
  border: 2px solid #3a4142;
  border-radius: 8px;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  transition: all 0.3s ease;

  ${(props) =>
    props.hasIcon &&
    `
    padding-right: 45px;
  `}

  &::placeholder {
    color: #6b7280;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #ffa500;
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
    background-color: #252828;
  }

  @media (max-width: 480px) {
    padding: 10px 14px;
    font-size: 16px; /* Prevent zoom on iOS */
  }
`;

const StyledInputss = styled.input`
  width: 100%;
  background-color: #1e2121;
  border: 2px solid #3a4142;
  border-radius: 8px;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  transition: all 0.3s ease;
  padding-right: 110px; /* to give room for the button inside */

  &::placeholder {
    color: #6b7280;
    font-weight: 400;
  }

  &:focus {
    outline: none;
    border-color: #ffa500;
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
    background-color: #252828;
  }

  @media (max-width: 480px) {
    padding: 10px 14px;
    padding-right: 110px;
    font-size: 16px; /* Prevent zoom on iOS */
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
`;

const SignUpButton = styled.button`
  width: 100%;
  background: linear-gradient(90deg, #ffd700, #ff8c00);
  box-shadow: 0 4px 15px rgba(255, 140, 0, 0.3);
  border: none;
  border-radius: 8px;
  color: #000;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 140, 0, 0.4);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 480px) {
    padding: 12px;
    font-size: 15px;
  }
`;

const SendOtpButton = styled.button`
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  height: 30px;
  padding: 0 10px;
  font-size: 0.9rem;
  border: none;
  color: black;
  border-radius: 4px;
  cursor: pointer;
  background: linear-gradient(90deg, #ffd700, #ff8c00);
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.3);
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-50%) translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 140, 0, 0.4);
  }
`;

const SignUpSection = styled.div`
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #3a4142;
  color: #9ca3af;
  font-size: 14px;
`;

const SignInButton = styled.button`
  background: none;
  border: none;
  color: #ffa500;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-left: 5px;

  &:hover {
    color: #ffb347;
    text-decoration: underline;
  }
`;

const StyledSignUpButton = styled.button`
  font-size: 16px;
  color: white;
  background-color: transparent;
  border: 1px solid #6b7280;
  border-radius: 6px;
  padding: 10px 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ffa500;
    color: #ffa500;
    background-color: rgba(255, 165, 0, 0.05);
  }
`;

const PhoneInputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogged: storage.getKey("logged"),
      show: this.props.show ? this.props.show : false,
      username: "",
      phone: "",
      email: "",
      password: "",
      confirmPassword: "",
      referral: this.props.referral || "",
      ruleChecked: false,
      ruleChecked18: false,
      submitted: false,
      disabled: false,
      effect: "zoomIn",
      isOtp: false,
      otp: "",
      requestId: "",
    };
  }

  componentDidMount() {
    socket.on(C.EDIT_FORGET_PASSWORD, (data) => this.setRegister(decode(data)));
    Event.on("register_form", () => {
      this.handleShow();
    });
  }

  setRegister = (data) => {
    console.log(data);
    if (data.error) {
      this.setState({ disabled: false, submitted: false });
      return sendNotfication(data.error, "success", "bottom-left");
    }

    if (data.status) {
      console.log("datataaaa", data);
      sendNotfication(
        "Successfully changed, Please loing...",
        "success",
        "bottom-left"
      );
      Event.emit("login_form");
    }
  };

  handleShow = () => {
    this.setState({ show: true, effect: "zoomIn" });
  };

  handleCloseF = () => {
    this.setState({
      show: false,
      effect: "zoomOut",
      disabled: false,
      submitted: false,
      ruleChecked: false,
      ruleChecked18: false,
    });
  };

  handleForgetSubmit = async (e) => {
    var verified;
    e.preventDefault();
    this.setState({ submitted: true, disabled: true });

    const { phone, password, confirmPassword, otp, requestId } = this.state;

    if (!phone) {
      sendNotfication("Please enter a phone number", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }

    if (isNaN(phone)) {
      sendNotfication(
        "Please enter a valid phone number",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }

    if (phone.length < 10 || phone.length > 15) {
      sendNotfication(
        "Please enter a valid phone number",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }
    if (!otp) {
      sendNotfication("Please enter a OTP", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }

    if (isNaN(otp)) {
      sendNotfication("Please enter a valid OTP", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }

    if (otp.length !== 6) {
      sendNotfication("Please enter a 6 digit OTP", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }

    if (!password) {
      sendNotfication("Please enter a password", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }
    if (!confirmPassword) {
      sendNotfication(
        "Please enter a confirm password",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }
    if (password !== confirmPassword) {
      sendNotfication("Passwords do not match", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }

    console.log({
      phone: phone,
      otp: otp,
      requestId: requestId,
      password: password,
    });

    socket.emit(
      C.EDIT_FORGET_PASSWORD,
      encode({
        phone: phone,
        otp: otp,
        requestId: requestId,
        password: password,
      })
    );
    this.handleCloseF();
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  login = () => {
    this.handleCloseF();
    Event.emit("login_form");
  };

  handleSendOtp = async () => {
    const { phone } = this.state;

    if (!phone) {
      sendNotfication("Please enter a phone number", "error", "bottom-left");
      this.setState({ disabled: false });
      return;
    }

    if (isNaN(phone)) {
      sendNotfication(
        "Please enter a valid phone number",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }

    if (phone.length < 10 || phone.length > 15) {
      sendNotfication(
        "Please enter a valid phone number",
        "error",
        "bottom-left"
      );
      this.setState({ disabled: false });
      return;
    }

    try {
      const response = await fetch(
        "https://api.betbazaar365.com/send-otp-otpless",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ phone }),
        }
      );

      const data = await response.json();

      if (data.status) {
        console.log(data);
        this.setState({ isOtp: true, requestId: data?.otp?.requestId });
        console.log(this.state.requestId);
        sendNotfication("OTP sent successfully!", "success", "bottom-left");
      } else {
        sendNotfication(
          data.message || "Failed to send OTP",
          "error",
          "bottom-left"
        );
      }
    } catch (err) {
      console.error("Error sending OTP:", err);
      alert("Something went wrong while sending OTP");
    }
  };

  render() {
    const {
      show,
      phone,
      password,
      confirmPassword,
      disabled,
      isOtp,
      otp,
      requestId,
    } = this.state;

    return (
      <>
        {storage.getKey("logged") ? (
          false
        ) : (
          <StyledSignUpButton
            onClick={this.handleShow}
            className="forget-password-trigger-btn"
            style={{ cursor: "pointer" }}
          >
            Forgot password?
          </StyledSignUpButton>
        )}

        <StyledModal
          size="lg"
          centered={false}
          show={storage.getKey("logged") ? false : show}
          onHide={this.handleCloseF}
          aria-labelledby="forget-password-modal"
          className={`forget-password-modal animated ${this.state.effect}`}
        >
          <LoginContainer className="forget-password-container">
            <LoginLeft className="forget-password-left-panel">
              <LoginTopImage
                className="forget-password-hero-image"
                src="/assets/bcimages/login/signup.png"
                alt="Reset Password Visual"
              />
              {/* <LoginLogoImage
                className="forget-password-brand-logo"
                src="/assets/bcimages/assamgames.png"
                alt="Brand Logo"
              /> */}
              <MobileCloseButton
                // onClick={this.handleCloseF}
                className="mobile-close-btn"
              >
                <Link to="/login"> ×</Link>
              </MobileCloseButton>
            </LoginLeft>

            <LoginRight className="forget-password-right-panel">
              <ModalHeader className="forget-password-header">
                <SignInTitle className="forget-password-title">
                  Reset password
                </SignInTitle>
                <CloseButton
                  // onClick={this.handleCloseF}
                  className="desktop-close-btn"
                >
                  <Link to="/login"> ×</Link>
                </CloseButton>
              </ModalHeader>

              <StyledForm
                onSubmit={this.handleForgetSubmit}
                className="forget-password-form"
              >
                <InputGroup className="phone-input-group">
                  <PhoneInputWrapper>
                    <StyledInputss
                      type="text"
                      name="phone"
                      value={phone}
                      onChange={this.handleInputChange}
                      placeholder="Phone Number"
                      className="phone-input"
                      autoComplete="tel"
                    />
                    <SendOtpButton type="button" onClick={this.handleSendOtp}>
                      Send OTP
                    </SendOtpButton>
                  </PhoneInputWrapper>
                </InputGroup>

                {isOtp && (
                  <InputGroup className="otp-input-group">
                    <StyledInput
                      type="text"
                      name="otp"
                      value={otp}
                      onChange={this.handleInputChange}
                      placeholder="Enter OTP"
                      className="otp-input"
                      autoComplete="one-time-code"
                    />
                  </InputGroup>
                )}

                <StyledInput
                  type="text"
                  name="requestId"
                  value={requestId}
                  onChange={this.handleInputChange}
                  placeholder="requestId"
                  style={{ display: "none" }}
                />

                <InputGroup className="password-input-group">
                  <StyledInput
                    type="password"
                    name="password"
                    value={password}
                    onChange={this.handleInputChange}
                    placeholder="New Password"
                    className="password-input"
                    autoComplete="new-password"
                  />
                </InputGroup>

                <InputGroup className="confirm-password-input-group">
                  <StyledInput
                    type="password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={this.handleInputChange}
                    placeholder="Confirm Password"
                    className="confirm-password-input"
                    autoComplete="new-password"
                  />
                </InputGroup>

                <ButtonContainer className="button-container">
                  <SignUpButton
                    type="submit"
                    disabled={disabled}
                    className="reset-password-submit-btn"
                  >
                    {disabled ? (
                      <>
                        <span
                          className="spinner-grow spinner-grow-sm mr-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      "Reset Password"
                    )}
                  </SignUpButton>
                </ButtonContainer>

                <SignUpSection className="signin-section">
                  Already have an account?
                  <SignInButton
                    // onClick={this.login}
                    className="signin-trigger-btn"
                  >
                    <Link to="/login">Sign in</Link>
                  </SignInButton>
                </SignUpSection>
              </StyledForm>
            </LoginRight>
          </LoginContainer>
        </StyledModal>
      </>
    );
  }
}

export default ForgetPassword;
